<template>
  <div class="pt-3">
    <b-form-select id="ddlCountries" size="md" :state="isValid" :value="selectedCountry" @change="setCountryCode">
      <template slot="first">
      <!-- this slot appears above the options from 'options' prop -->
      <option :value="null" disabled>-- Please select a country --</option>
      </template>
      <option
        v-for="country in sortedCountries"
        v-bind:key="country.value"
        :value="country.value"
        >{{ country.text }}</option
      >
    </b-form-select>
    
  </div>
</template>

<script>
export default {
  name: "Countries",
  props: ['CountryCodeValue', 'isValid'],
  data: () => ({
    //selectedCountry: this.CountryCodeValue,
    countries: [
      { text: "United States", value: "US" },
      { text: "Canada", value: "CA" },
      { text: "Haiti", value: "HT" },
      { text: "Cuba", value: "CU" },
      { text: "Mexico", value: "MX" },
      { text: "Colombia", value: "CO" },
      { text: "Jamaica", value: "JM" },
      { text: "Guatemala", value: "GT" },
      { text: "Honduras", value: "HN" },
      { text: "Peru", value: "PE" },
      { text: "Brazil", value: "BR" },
      { text: "Puerto Rico (US)", value: "PR" },
      { text: "Andorra", value: "AD" },
      { text: "United Arab Emirates", value: "AE" },
      { text: "Afghanistan", value: "AF" },
      { text: "Antigua and Barbuda", value: "AG" },
      { text: "Anguilla (UK)", value: "AI" },
      { text: "Albania", value: "AL" },
      { text: "Armenia", value: "AM" },
      { text: "Netherlands Antilles (NL)", value: "AN" },
      { text: "Angola", value: "AO" },
      { text: "Argentina", value: "AR" },
      { text: "American Samoa (US)", value: "AS" },
      { text: "Austria", value: "AT" },
      { text: "Australia", value: "AU" },
      { text: "Aruba", value: "AW" },
      { text: "Azerbaijan", value: "AZ" },
      { text: "Bosnia and Herzegovina", value: "BA" },
      { text: "Barbados", value: "BB" },
      { text: "Bangladesh", value: "BD" },
      { text: "Belgium", value: "BE" },
      { text: "Burkina Faso", value: "BF" },
      { text: "Bulgaria", value: "BG" },
      { text: "Bahrain", value: "BH" },
      { text: "Burundi", value: "BI" },
      { text: "Benin", value: "BJ" },
      { text: "Bermuda (UK)", value: "BM" },
      { text: "Brunei Darussalam", value: "BN" },
      { text: "Bolivia", value: "BO" },
      { text: "Bahamas", value: "BS" },
      { text: "Bhutan", value: "BT" },
      { text: "Botswana", value: "BW" },
      { text: "Belarus", value: "BY" },
      { text: "Belize", value: "BZ" },
      { text: "Cocos (Keeling) Islands (AU)", value: "CC" },
      { text: "Congo, Democratic Republic of the", value: "CD" },
      { text: "Central African Republic", value: "CF" },
      { text: "Congo, Republic of the", value: "CG" },
      { text: "Switzerland", value: "CH" },
      { text: "Cote D'Ivoire", value: "CI" },
      { text: "Cook Islands (NZ)", value: "CK" },
      { text: "Chile", value: "CL" },
      { text: "Cameroon", value: "CM" },
      { text: "China", value: "CN" },
      { text: "Costa Rica", value: "CR" },
      { text: "Serbia and Montenegro", value: "CS" },
      { text: "Cape Verde", value: "CV" },
      { text: "Christmas Island (AU)", value: "CX" },
      { text: "Cyprus", value: "CY" },
      { text: "Czech Republic", value: "CZ" },
      { text: "Germany", value: "DE" },
      { text: "Djibouti", value: "DJ" },
      { text: "Denmark", value: "DK" },
      { text: "Dominica", value: "DM" },
      { text: "Dominican Republic", value: "DO" },
      { text: "Algeria", value: "DZ" },
      { text: "Ecuador", value: "EC" },
      { text: "Estonia", value: "EE" },
      { text: "Egypt", value: "EG" },
      { text: "Western Sahara", value: "EH" },
      { text: "Eritrea", value: "ER" },
      { text: "Spain", value: "ES" },
      { text: "Ethiopia", value: "ET" },
      { text: "Finland", value: "FI" },
      { text: "Fiji", value: "FJ" },
      { text: "Falkland Islands (UK)", value: "FK" },
      { text: "Micronesia, Federated States of", value: "FM" },
      { text: "Faroe Islands (DK)", value: "FO" },
      { text: "France", value: "FR" },
      { text: "Gabon", value: "GA" },
      { text: "United Kingdom", value: "GB" },
      { text: "Grenada", value: "GD" },
      { text: "Georgia", value: "GE" },
      { text: "French Guiana (FR)", value: "GF" },
      { text: "Ghana", value: "GH" },
      { text: "Gibraltar (UK)", value: "GI" },
      { text: "Greenland (DK)", value: "GL" },
      { text: "Gambia", value: "GM" },
      { text: "Guinea", value: "GN" },
      { text: "Guadeloupe (FR)", value: "GP" },
      { text: "Equatorial Guinea", value: "GQ" },
      { text: "Greece", value: "GR" },
      { text: "South Georgia & South Sandwich Islands (UK)", value: "GS" },
      { text: "Guam (US)", value: "GU" },
      { text: "Guinea-Bissau", value: "GW" },
      { text: "Guyana", value: "GY" },
      { text: "Hong Kong (CN)", value: "HK" },
      { text: "Croatia", value: "HR" },
      { text: "Hungary", value: "HU" },
      { text: "Indonesia", value: "ID" },
      { text: "Ireland", value: "IE" },
      { text: "Israel", value: "IL" },
      { text: "India", value: "IN" },
      { text: "Iraq", value: "IQ" },
      { text: "Iran", value: "IR" },
      { text: "Iceland", value: "IS" },
      { text: "Italy", value: "IT" },
      { text: "Jordan", value: "JO" },
      { text: "Japan", value: "JP" },
      { text: "Kenya", value: "KE" },
      { text: "Kyrgyzstan", value: "KG" },
      { text: "Cambodia", value: "KH" },
      { text: "Kiribati", value: "KI" },
      { text: "Comoros Islands", value: "KM" },
      { text: "Saint Kitts and Nevis", value: "KN" },
      { text: "Korea, Democratic People's Republic (North)", value: "KP" },
      { text: "Korea, Republic of (South)", value: "KR" },
      { text: "Kuwait", value: "KW" },
      { text: "Cayman Islands (UK)", value: "KY" },
      { text: "Kazakhstan", value: "KZ" },
      { text: "Laos", value: "LA" },
      { text: "Lebanon", value: "LB" },
      { text: "Saint Lucia", value: "LC" },
      { text: "Liechtenstein", value: "LI" },
      { text: "Sri Lanka", value: "LK" },
      { text: "Liberia", value: "LR" },
      { text: "Lesotho", value: "LS" },
      { text: "Lithuania", value: "LT" },
      { text: "Luxembourg", value: "LU" },
      { text: "Latvia", value: "LV" },
      { text: "Libya", value: "LY" },
      { text: "Morocco", value: "MA" },
      { text: "Monaco", value: "MC" },
      { text: "Moldova", value: "MD" },
      { text: "Madagascar", value: "MG" },
      { text: "Marshall Islands", value: "MH" },
      { text: "Macedonia", value: "MK" },
      { text: "Mali", value: "ML" },
      { text: "Burma", value: "MM" },
      { text: "Mongolia", value: "MN" },
      { text: "Macau (CN)", value: "MO" },
      { text: "Northern Mariana Islands (US)", value: "MP" },
      { text: "Martinique (FR)", value: "MQ" },
      { text: "Mauritania", value: "MR" },
      { text: "Montserrat (UK)", value: "MS" },
      { text: "Malta", value: "MT" },
      { text: "Mauritius", value: "MU" },
      { text: "Maldives", value: "MV" },
      { text: "Malawi", value: "MW" },
      { text: "Malaysia", value: "MY" },
      { text: "Mozambique", value: "MZ" },
      { text: "Namibia", value: "NA" },
      { text: "New Caledonia (FR)", value: "NC" },
      { text: "Niger", value: "NE" },
      { text: "Norfolk Island (AU)", value: "NF" },
      { text: "Nigeria", value: "NG" },
      { text: "Nicaragua", value: "NI" },
      { text: "Netherlands", value: "NL" },
      { text: "Norway", value: "NO" },
      { text: "Nepal", value: "NP" },
      { text: "Nauru", value: "NR" },
      { text: "Niue", value: "NU" },
      { text: "New Zealand", value: "NZ" },
      { text: "Oman", value: "OM" },
      { text: "Panama", value: "PA" },
      { text: "French Polynesia (FR)", value: "PF" },
      { text: "Papua New Guinea", value: "PG" },
      { text: "Philippines", value: "PH" },
      { text: "Pakistan", value: "PK" },
      { text: "Poland", value: "PL" },
      { text: "Saint Pierre & Miquelon (FR)", value: "PM" },
      { text: "Pitcairn Islands (UK)", value: "PN" },
      { text: "Portugal", value: "PT" },
      { text: "Palau", value: "PW" },
      { text: "Paraguay", value: "PY" },
      { text: "Qatar", value: "QA" },
      { text: "Reunion (FR)", value: "RE" },
      { text: "Romania", value: "RO" },
      { text: "Russia", value: "RU" },
      { text: "Rwanda", value: "RW" },
      { text: "Saudi Arabia", value: "SA" },
      { text: "Solomon Islands", value: "SB" },
      { text: "Seychelles", value: "SC" },
      { text: "Sudan", value: "SD" },
      { text: "Sweden", value: "SE" },
      { text: "Singapore", value: "SG" },
      { text: "Saint Helena (UK)", value: "SH" },
      { text: "Slovenia", value: "SI" },
      { text: "Slovakia", value: "SK" },
      { text: "Sierra Leone", value: "SL" },
      { text: "San Marino", value: "SM" },
      { text: "Senegal", value: "SN" },
      { text: "Somalia", value: "SO" },
      { text: "Suriname", value: "SR" },
      { text: "Sao Tome and Principe", value: "ST" },
      { text: "El Salvador", value: "SV" },
      { text: "Syria", value: "SY" },
      { text: "Swaziland", value: "SZ" },
      { text: "Turks and Caicos Islands (UK)", value: "TC" },
      { text: "Chad", value: "TD" },
      { text: "Togo", value: "TG" },
      { text: "Thailand", value: "TH" },
      { text: "Tajikistan", value: "TJ" },
      { text: "Tokelau", value: "TK" },
      { text: "Turkmenistan", value: "TM" },
      { text: "Tunisia", value: "TN" },
      { text: "Tonga", value: "TO" },
      { text: "East Timor", value: "TP" },
      { text: "Turkey", value: "TR" },
      { text: "Trinidad and Tobago", value: "TT" },
      { text: "Tuvalu", value: "TV" },
      { text: "Taiwan", value: "TW" },
      { text: "Tanzania", value: "TZ" },
      { text: "Ukraine", value: "UA" },
      { text: "Uganda", value: "UG" },
      { text: "Uruguay", value: "UY" },
      { text: "Uzbekistan", value: "UZ" },
      { text: "Holy See (Vatican City)", value: "VA" },
      { text: "Saint Vincent and the Grenadines", value: "VC" },
      { text: "Venezuela", value: "VE" },
      { text: "British Virgin Islands (UK)", value: "VG" },
      { text: "Virgin Islands (US)", value: "VI" },
      { text: "Vietnam", value: "VN" },
      { text: "Vanuatu", value: "VU" },
      { text: "Wallis and Futuna (DFR)", value: "WF" },
      { text: "Samoa", value: "WS" },
      { text: "Yemen", value: "YE" },
      { text: "Mayotte (FR)", value: "YT" },
      { text: "South Africa", value: "ZA" },
      { text: "Zambia", value: "ZM" },
      { text: "Zimbabwe", value: "ZW" }
    ]
    
  }),
  methods: {
    setCountryCode(event){
      console.log('setting the country (DLL) to: ' + event);
      this.$emit('set-country', event);
    }
  },
  computed: {
    selectedCountry(){
      return this.CountryCodeValue;
    },
    sortedCountries(){
      return this.countries.sort((a, b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0));
    }
  }
};
</script>
